var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-row',[_c('b-col',{staticClass:"col-md-12 col-lg-12"},[_c('vue-apex-charts',{attrs:{"type":"line","height":"325px","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }